import firestore from "src/apiService/firestore";

const db = firestore();

export const markErrorAlertViewed = async (errorAlertId: string) => {
  const ref = db.collection("Error_Alerts").doc(errorAlertId);
  return ref.set({ new: false }, { merge: true });
};
